import { render } from "./PackageProspectSettingsModal.vue?vue&type=template&id=0abff245&scoped=true"
import script from "./PackageProspectSettingsModal.vue?vue&type=script&lang=js"
export * from "./PackageProspectSettingsModal.vue?vue&type=script&lang=js"

import "./PackageProspectSettingsModal.vue?vue&type=style&index=0&id=0abff245&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abff245"]])

export default __exports__